@if (reviewConfig) {
    <generic-list-manager [config]="reviewConfig"></generic-list-manager>
}
